// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader/dist/cjs.js?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-90f9f5a2!./~/sass-loader/lib/loader.js?sourceMap!./src/components/Chat/Chat.scss
// module id = 463
// module chunks = 0